import { Logo } from '@zuruflex/ui';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../lib/auth.js';
import { SignInPage } from '../pages/SignInPage.js';
import { AgreementGate } from './AgreementGate.js';

/**
 * Sign-in is rendered in place rather than redirected to, so the link a
 * partner followed from an email survives being asked to sign in.
 *
 * Signed in is not the same as let in. Everything behind this gate happens
 * under Zuruflex's partner agreement, so a partner who has not accepted the
 * version in force meets it here — before the portal, not as a banner
 * inside it.
 */
export function RequireAuth() {
  const { partner, isRestoring } = useAuth();
  const { t } = useTranslation('common');

  if (isRestoring) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-surface">
        <Logo variant="mark" className="size-8 animate-pulse" />
        <p className="text-sm text-text-muted">{t('state.loading')}</p>
      </div>
    );
  }

  if (!partner) return <SignInPage />;

  return (
    <AgreementGate>
      <Outlet />
    </AgreementGate>
  );
}
